import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router";
import Api from "../../services/Api.ts";
import { CategoryInterface} from "../interfaces/category_interfaces.ts";
import {CONFIG} from "../../constants.ts";
import Breadcrumbs, {Crumb} from "../../components/Breadcrumbs/Breadcrumbs.tsx";
import {languageMap, surveyLanguages} from "../../helpers/languages.ts";
import {ChevronDown} from "flowbite-react-icons/outline";
import {Button, Checkbox, Label} from "flowbite-react"


export default function Category() {
  const api = Api.getInstance();
  const { categoryId } = useParams();
  const navigate = useNavigate();
  const [category, setCategory] = useState<CategoryInterface>({id: "", name: "", files: [], surveys: []});
  const [surveyName, setSurveyName] = useState("");
  const [surveyLanguage, setSurveyLanguage] = useState("en");
  const [answerOptions, setAnswerOptions] = useState(5);
  const [answerType, setAnswerType] = useState(0);
  const [showNoAnswer, setShowNoAnswer] = useState(true);
  const [showCreate, setShowCreate] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    api.get('customer/categories/' + categoryId).then((response) => {
      setCategory(response.json.category);
      setLoaded(true);
    })
  }

  const addSurvey = () => {
    const data = {
      name: surveyName,
      answerOptions: answerOptions,
      categoryId: categoryId,
      showNoAnswer: showNoAnswer,
      answerType: answerType,
      defaultLanguage: surveyLanguage
    }
    api.post('customer/survey_add', data).then(response => {
      if (response.json.status === "ok") {
        const surveyId = response.json.surveyId
        navigate(`/categories/survey/${surveyId}`);
      }
    })
  }

  if (!loaded) {
    return <div>Loading data...</div>
  }

  const crumbs: Array<Crumb> = [
    {
      name: "Categories",
      link: "/categories"
    },
    {
      name: category.name
    }
  ]

  const showSurveys = () => {
    if (category.surveys.length === 0) {
      return (
        <div className="mt-1 text-neutral-400">No surveys in this category.</div>
      )
    }
    return (
      <table className="z-table z-spacing mt-2">
        <thead>
        <tr>
          <th></th>
          <th>Locked</th>
          <th>Approved</th>
          <th>Languages</th>
        </tr>
        </thead>
        <tbody>
        {
          category.surveys.map((survey, i) => (
            <tr key={"survey_" + i}>
              <td className="text-xl cursor-pointer"
                  onClick={() => navigate('/categories/survey/' + survey.id)}>
                {survey.name}
              </td>
              <td>{survey.locked ? "Yes" : "No"}</td>
              <td>{survey.approved ? "Yes" : "No"}</td>
              <td>{survey.languages.length}</td>
            </tr>
          ))
        }
        </tbody>
      </table>
    )
  }

  return (
    <div className="main">
      <Breadcrumbs crumbs={crumbs}/>
      <div className="mt-4 text-3xl font-medium">{category.name}</div>

      <div className="mt-4">
        <p className="text-xl">Files in this category</p>

        {
          category.files.map((file, i) => (
            <div className="mt-1" key={"file_" + i}>
              <a target="_blank" className="text-neutral-400"
                 href={CONFIG.API_ENDPOINT + "customer/file/" + file.file_id + "/" + api.apiToken}>
                {file.name}
              </a>
            </div>
          ))
        }

        <p className="text-xl mt-4">Surveys</p>
        <div className="mt-2 z-box">
          {showSurveys()}
        </div>

        <div className="text-xl mt-8 cursor-pointer flex items-center" onClick={() => setShowCreate(!showCreate)}>
          <p>Create new survey</p>
          <ChevronDown className={"ml-2 h-6 w-6 " + (showCreate ? "rotate-180" : "")}/>
        </div>

        {
          showCreate &&
            <>
                <div className="mt-2">
                    <input type="z-input" value={surveyName} className="z-input" placeholder="Survey name"
                           onChange={(e) => setSurveyName(e.target.value)}/>
                </div>

                <div className="mt-2">
                    Default language:&nbsp;
                    <select className="mt-2 z-select" value={surveyLanguage}
                            onChange={(e) => setSurveyLanguage(e.target.value)}
                    >
                      {
                        surveyLanguages.map(lang => (
                          <option value={lang} key={"lang_" + lang}>{languageMap[lang]}</option>
                        ))
                      }
                    </select>
                </div>


                <div className="mt-2">
                    Answer options:&nbsp;
                    <select className="mt-2 z-select" value={answerOptions}
                            onChange={(e) => setAnswerOptions(parseInt(e.target.value))}>
                        <option value={3}>3</option>
                        <option value={5}>5</option>
                        <option value={7}>7</option>
                        <option value={10}>10</option>
                    </select>
                </div>

                <div className="mt-2 flex gap-x-2 items-center">
                    <Checkbox style={{borderRadius: "50%"}} className="h-6 w-6" id="show_no_answer"
                              checked={showNoAnswer} onChange={() => setShowNoAnswer(!showNoAnswer)}/>
                    <Label htmlFor="show_no_answer">Include a don't know option</Label>
                </div>

                <div className="mt-2">
                    Answer scale:&nbsp;
                    <select className="mt-2 z-select" value={answerType}
                            onChange={(e) => setAnswerType(parseInt(e.target.value))}>
                        <option value={0}>Disagree - Agree</option>
                        <option value={1}>Bad - Good</option>
                        <option value={2}>Behavioral (Never to Always)</option>
                    </select>
                </div>

              <Button disabled={surveyName.length < 2} className="mt-4" onClick={() => addSurvey()}>
                    Add Survey
                </Button>
            </>
        }


      </div>
    </div>
  );
}